import React from 'react';
import styles from './CWSection.module.scss';

export default function CWSection({ number, children, intro }) {

    return (
        <div className={styles.cwSectionContainer}>
            <div className={styles.cwSectionLeft}>
                <div className={styles.cwSetionCircle}>{number}</div>
                <div className={styles.cwSetionBorder} />
            </div>
            <div className={styles.cwSectionContent}>
                <b>{intro}</b>
                {children}
            </div>
        </div>
    );
};